export enum PartnerFormMenuItems {
  Basic = 0,
  Legal = 1,
  Additional = 2,
  Attachments = 3,
  ProgramCodes = 4,
  Accreditation = 5,
}
